import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../context/User';
import { API, getLogo, showError, showInfo, showSuccess } from '../helpers';
import { onGitHubOAuthClicked } from './utils';
import Turnstile from 'react-turnstile';
import { Button, Card, Divider, Form, Icon, Modal } from '@douyinfe/semi-ui';
import Title from '@douyinfe/semi-ui/lib/es/typography/title';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import TelegramLoginButton from 'react-telegram-login';

import { IconGithubLogo } from '@douyinfe/semi-icons';
import WeChatIcon from './WeChatIcon';

const LoginForm = () => {
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
    wechat_verification_code: ''
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [submitted, setSubmitted] = useState(false);
  const { username, password } = inputs;
  const [userState, userDispatch] = useContext(UserContext);
  const [turnstileEnabled, setTurnstileEnabled] = useState(false);
  const [turnstileSiteKey, setTurnstileSiteKey] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  let navigate = useNavigate();
  const [status, setStatus] = useState({});
  const logo = getLogo();

  useEffect(() => {
    if (searchParams.get('expired')) {
      showError('未登录或登录已过期，请重新登录！');
    }
    let status = localStorage.getItem('status');
    if (status) {
      status = JSON.parse(status);
      setStatus(status);
      if (status.turnstile_check) {
        setTurnstileEnabled(true);
        setTurnstileSiteKey(status.turnstile_site_key);
      }
    }
  }, []);

  const [showWeChatLoginModal, setShowWeChatLoginModal] = useState(false);

  const onWeChatLoginClicked = () => {
    setShowWeChatLoginModal(true);
  };

  const onSubmitWeChatVerificationCode = async () => {
    if (turnstileEnabled && turnstileToken === '') {
      showInfo('请稍后几秒重试，Turnstile 正在检查用户环境！');
      return;
    }
    const res = await API.get(
      `/api/oauth/wechat?code=${inputs.wechat_verification_code}`
    );
    const { success, message, data } = res.data;
    if (success) {
      userDispatch({ type: 'login', payload: data });
      localStorage.setItem('user', JSON.stringify(data));
      navigate('/');
      showSuccess('登录成功！');
      setShowWeChatLoginModal(false);
    } else {
      showError(message);
    }
  };

  function handleChange(name, value) {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  }

  async function handleSubmit(e) {
    if (turnstileEnabled && turnstileToken === '') {
      showInfo('请稍后几秒重试，Turnstile 正在检查用户环境！');
      return;
    }
    setSubmitted(true);
    if (username && password) {
      const res = await API.post(`/api/user/login?turnstile=${turnstileToken}`, {
        username,
        password
      });
      const { success, message, data } = res.data;
      if (success) {
        userDispatch({ type: 'login', payload: data });
        localStorage.setItem('user', JSON.stringify(data));
        showSuccess('登录成功！');
        if (username === 'root' && password === '123456') {
          Modal.error({ title: '您正在使用默认密码！', content: '请立刻修改默认密码！', centered: true });
        }
        navigate('/token');
      } else {
        showError(message);
      }
    } else {
      showError('请输入用户名和密码！');
    }
  }

  // 添加Telegram登录处理函数
  const onTelegramLoginClicked = async (response) => {
    const fields = ['id', 'first_name', 'last_name', 'username', 'photo_url', 'auth_date', 'hash', 'lang'];
    const params = {};
    fields.forEach((field) => {
      if (response[field]) {
        params[field] = response[field];
      }
    });
    const res = await API.get(`/api/oauth/telegram/login`, { params });
    const { success, message, data } = res.data;
    if (success) {
      userDispatch({ type: 'login', payload: data });
      localStorage.setItem('user', JSON.stringify(data));
      showSuccess('登录成功！');
      navigate('/');
    } else {
      showError(message);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>
        {/* Logo 和品牌名称 */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '32px'
        }}>
          <img 
            src={logo} 
            alt="Logo" 
            style={{ 
              width: '64px', 
              height: '64px',
              marginBottom: '16px'
            }} 
          />
          <Title heading={2} style={{ 
            margin: 0, 
            color: '#303133',
            fontWeight: '600'
          }}>
            用户登录
          </Title>
          <Text style={{ 
            color: '#909399', 
            marginTop: '8px',
            fontSize: '14px'
          }}>
            欢迎回来，请登录您的账户
          </Text>
        </div>

        <Card 
          style={{ 
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            border: '1px solid #e4e7ed'
          }}
        >
          <div style={{ padding: '32px' }}>
            <Form>
              <Form.Input
                field={'username'}
                label={'用户名'}
                placeholder="请输入用户名"
                name="username"
                size="large"
                style={{ marginBottom: '20px' }}
                onChange={(value) => handleChange('username', value)}
              />
              <Form.Input
                field={'password'}
                label={'密码'}
                placeholder="请输入密码"
                name="password"
                type="password"
                size="large"
                style={{ marginBottom: '24px' }}
                onChange={(value) => handleChange('password', value)}
              />

              <Button 
                theme="solid" 
                style={{ 
                  width: '100%',
                  background: '#409eff',
                  border: 'none',
                  height: '40px',
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '4px'
                }} 
                type={'primary'} 
                size="large"
                htmlType={'submit'} 
                onClick={handleSubmit}>
                登录
              </Button>
            </Form>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginTop: '16px',
              fontSize: '14px'
            }}>
              <Text>
                没有账号？
                <Link to="/register" style={{ 
                  color: '#409eff',
                  textDecoration: 'none',
                  marginLeft: '4px'
                }}>
                  立即注册
                </Link>
              </Text>
              <Text>
                <Link to="/reset" style={{ 
                  color: '#409eff',
                  textDecoration: 'none'
                }}>
                  忘记密码
                </Link>
              </Text>
            </div>

            {status.github_oauth || status.wechat_login || status.telegram_oauth ? (
              <>
                <Divider margin="24px" align="center">
                  <Text style={{ color: '#909399', fontSize: '14px' }}>
                    第三方登录
                  </Text>
                </Divider>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                  {status.github_oauth ? (
                    <Button
                      type="primary"
                      icon={<IconGithubLogo />}
                      onClick={() => onGitHubOAuthClicked(status.github_client_id)}
                      style={{ 
                        width: '44px',
                        height: '44px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    />
                  ) : null}
                  {status.wechat_login ? (
                    <Button
                      type="primary"
                      style={{ 
                        color: '#67c23a',
                        width: '44px',
                        height: '44px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      icon={<Icon svg={<WeChatIcon />} />}
                      onClick={onWeChatLoginClicked}
                    />
                  ) : null}
                  {status.telegram_oauth ? (
                    <TelegramLoginButton dataOnauth={onTelegramLoginClicked} botName={status.telegram_bot_name} />
                  ) : null}
                </div>
              </>
            ) : null}

            <Modal
              title="微信扫码登录"
              visible={showWeChatLoginModal}
              maskClosable={true}
              onOk={onSubmitWeChatVerificationCode}
              onCancel={() => setShowWeChatLoginModal(false)}
              okText={'登录'}
              size={'small'}
              centered={true}
            >
              <div style={{ display: 'flex', alignItem: 'center', flexDirection: 'column' }}>
                <img src={status.wechat_qrcode} />
              </div>
              <div style={{ textAlign: 'center' }}>
                <p>
                  微信扫码关注公众号，输入「验证码」获取验证码（三分钟内有效）
                </p>
              </div>
              <Form size="large">
                <Form.Input
                  field={'wechat_verification_code'}
                  placeholder="验证码"
                  label={'验证码'}
                  value={inputs.wechat_verification_code}
                  onChange={(value) => handleChange('wechat_verification_code', value)}
                />
              </Form>
            </Modal>
          </div>
        </Card>

        {turnstileEnabled && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Turnstile
              sitekey={turnstileSiteKey}
              onVerify={(token) => {
                setTurnstileToken(token);
              }}
            />
          </div>
        )}

        {/* 底部版权信息 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '32px',
          color: '#c0c4cc',
          fontSize: '12px'
        }}>
          © 2026 AI API Platform. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
